import { useAtomValue } from 'jotai'
import { permissionsAtom } from '@/store/auth.atom'
import type { Permission } from '@/types/auth.types'

type PermissionInput = Permission | Permission[]

interface UsePermissionOptions {
    mode?: 'any' | 'all'
}

export function usePermission(
    permission: PermissionInput,
    { mode = 'any' }: UsePermissionOptions = {},
): boolean {
    const permissions = useAtomValue(permissionsAtom)

    if (Array.isArray(permission)) {
        if (permission.length === 0) return true 
        return mode === 'all'
            ? permission.every((p) => permissions.includes(p))
            : permission.some((p) => permissions.includes(p))
    }

    return permissions.includes(permission)
}